// Import page components
import RootLayout from "./pages/RootLayout";
import HomePage from "./pages/HomePage";
import ModelosPage from "./pages/ModelosPage";
import AccesoriosPage from "./pages/AccesoriosPage";
import MerchandisingPage from "./pages/MerchandisingPage";
import MantencionesPage from "./pages/MantencionesPage";
import ModeloPage from "./pages/ModeloPage";
import MantencionPage from "./pages/MantencionPage";
import MerchandisingItemPage from "./pages/MerchandisingItemPage";
import AccesorioPage from "./pages/AccesorioPage";
import DiscountsPage from "./pages/DiscountsPage";
import AyudaPage from "./pages/AyudaPage";
import FinanciacionPage from "./pages/FinanciacionPage";
import CheckoutPage from "./pages/CheckoutPage";
import MessagePage from "./pages/MessagePage";
import CartPage from "./pages/CartPage";
import TerminosCondicionesPage from "./pages/TerminosCondicionesPage";
import PrivacidadLegalesPage from "./pages/PrivacidadLegalesPage";

// Import React Router v6.4 components and hooks
import {
    createRoutesFromElements,
    Route,
    RouterProvider,
    Navigate,
    createBrowserRouter,
} from "react-router-dom";

const dataFinanceOn = document.getElementById('store-app').getAttribute('data-finance-on');
const financeOn = dataFinanceOn === 'True';

/**
 * Routes with React Router v6.4 syntax
 * https://reactrouter.com/en/main/start/tutorial
 * https://www.youtube.com/watch?v=L2kzUg6IzxM
 */
const pathParts = window.location.pathname.split('/');
const lang = pathParts[1] || 'es';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<RootLayout />}>
            <Route index element={<HomePage />} />

            <Route path="/modelos">
                <Route index element={<ModelosPage />} />
                <Route path=":modeloId" element={<ModeloPage financeOn={ financeOn } />} />
            </Route>

            <Route path="/mantenciones">
                <Route index element={<MantencionesPage />} />
                <Route path=":mantencionId" element={<MantencionPage />} />
            </Route>

            <Route path="/accesorios">
                <Route index element={<AccesoriosPage />} />
                <Route path=":accesorioId" element={<AccesorioPage />} />
            </Route>

            <Route path="/merchandising">
                <Route index element={<MerchandisingPage />} />
                <Route
                    path=":merchandisingId"
                    element={<MerchandisingItemPage />}
                />
            </Route>

            <Route path="/descuentos" element={<DiscountsPage />} />

            {/* <Route path="/posventa" element={<h2 style={{ padding: "15rem 2rem" }}>Post Venta</h2>} /> */}

            <Route path="/financiacion" element={<FinanciacionPage />} />

            <Route path="/ayuda" element={<AyudaPage />} />

            <Route
                path="/politicas-de-privacidad"
                element={<PrivacidadLegalesPage />}
            />

            <Route
                path="/terminos-y-condiciones"
                element={<TerminosCondicionesPage />}
            />

            <Route path="/carrito">
                <Route index element={<CartPage />} />
                <Route path="checkout" element={<CheckoutPage />} />
            </Route>

            <Route path="/error" element={<MessagePage error={404} />} />

            <Route
                path="/error-en-compra"
                element={<MessagePage error={"paymentFailed"} />}
            />

            <Route
                path="/pago-rechazado"
                element={<MessagePage error={"paymentDeclined"} />}
            />

            <Route
                path="/gracias-por-su-compra"
                element={<MessagePage success={"purchase"} />}
            />

            <Route path="*" element={<Navigate to="/error" replace />} />
        </Route>
    ),
    { basename: `/${lang}/tienda` }
);

// Define the main App component
const App = () => {
    // Log the initialization of the React application
    console.log("app init - react");

    // Render the RouterProvider component with the defined router
    return <RouterProvider router={router} />;
};

// Export the App component as the default export
export default App;
